<template>
  <div class="activity-wrap">
    <app-header />
    <div class="banner_main">
      <div class="content_box">
        <img
          src="../../assets/images/activity/activityforecast2024/jgcl_banner_text.png"
        />
      </div>
    </div>
    <div class="content_main">
      <div class="main_box">
        <div class="header_main">
          <p>一图看懂机构2024策略前瞻</p>
          <p>YITUKANDONGJIROU2024CELUVQIANZHAN</p>
        </div>
        <div class="text_box">
          临近年底，多家券商机构发布了2024年策略报告，对新一年的宏观政策、市场走势、配置方向等作出最新研判。<br />
          展望明年经济形势，多家机构持谨慎乐观预期，认为明年国内经济复苏有望呈现逐 步加快的态势，A股有望迎来估值修复。
        </div>
        <div class="table_main_box">
          <table cellspacing="0" cellpadding="0">
            <tr>
              <th width="113">机构</th>
              <th width="148">核心观点</th>
              <th>概念题材</th>
            </tr>
            <tr class="td_box" v-for="(item, index) in topList" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.pointView }}</td>
              <td v-html="item.content"></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <p class="footer_box">投资有风险，入市需谨慎</p>
  </div>
</template>
    <script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      token: "",
      topList: [
        {
          name: "中信建投",
          pointView: "熊牛转换静待春风",
          content:
            "我们预计 2024 年 A 股有望呈现小牛市，未来将进入熊牛转换期，2024 年至少有两大因素改善，一是全球宏观流动性明显改善，二是国内稳增长力度增强。<br/>这将推动 2024 年 A 股盈利正增长，估值修复。在熊牛转换期的策略思路：需逐步由守转攻，配置可考虑看涨期权思维。<br/>三条线索：一是产业周期+困境反转；二是顺周期悲观一致预期下存在估值修复机会，三是看涨期权思维，高股息中选择进攻属性。",
        },
        {
          name: "海通证券",
          pointView: "科技和消费望驱动，24 年 A 股盈利",
          content:
            "宏观层面，今年以来经济修复整体呈现“波浪式发展、曲折式前进”的特征，展望 24 年，货币政策或维持稳健宽松，积极财政空间大，地产销售、居民消费均有望改善。<br/>综合来看，随着稳增长政策持续发力，叠加库存周期进入补库阶段，明年国内经济运行有望进一步好转，我们预计 24 年国内实际 GDP 同比增速有望达 5%左右。<br/>中观层面，科技+消费行业或成为拉动 24 年 A 股盈利增长的主要驱动力。科技方面，受益于政策支持与技术赋能，科技产业链有望快速增长，关注电子行业。消费方面，消费修复、经济转型的大背景下，消费可能存在结构性机会，重视医药、社服行业。除了科技和消费两大核心主线外，其他板块或也有结构性亮点值得重视。",
        },
        {
          name: "信达证券",
          pointView: "2024 年有望进入牛熊转折年",
          content:
            "2024 年值得期待的三点乐观变化。 <br/>（1）库存周期不会消失：库存周期不会消失，一旦反转会对股市产生半年以上的正面影响。1990-2009 年，日本经济在失去的二十年中，在库存周期下降末期到回升初期，日经 225 指数很容易出现半年以上的反弹。<br/>（2）房地产销售也可能会出现反弹：因为参考日本的经验，下行周期初期也会出现 2-3 年的销售反弹。战术层面市场对房地产政策最乐观的对比是 2014 年“930 新政”。<br>（3）美国经济有可能软着陆。<br/>配置策略：上游周期（或有 1-2 年的长期上涨机会）+AI、汽车零部件、金融类（这三个板块未来一年内大概率有机会）+成长（底部反转后 2-3 个月）。",
        },
        {
          name: "安信证券",
          pointView: "2024大盘指数曲折中前行，科技+出海是超额核心主线",
          content:
            "大势研判：2024年大盘指数在曲折中前行，节奏上倾向是N字型，把握结构依然是2024年超额收益的重心。<br/>风格研判：大盘价值高股息+小盘成长双主线不是短期趋势，2025年之前大概率维持双主线占优格局，小盘成长对应的产业主题投资依然很重要；大盘成长偏向是波段性机遇。<br/>短期超配行业：科技股美股映射（ TMT+医药+人形机器人）；产业全球竞争力 （机器人零部件、汽车零部件、创新药、光模块、白电、纺服、跨境电商）、高股息（能源、电力和运营商）；消费平替（智能手机、预制菜、冷冻食品、智能家居、零糖饮料）。指数投资：科创 100 指数。",
        },
        {
          name: "渤海证券",
          pointView: "信心修复与政策红利的共振",
          content:
            "宏观方面，2023 年，经济的平稳修复带来了增长质量的提升。2024年，国内经济可能最终强于市场预期。<br/>海外方面，10 年期美债收益率将见顶回落，全球流动性拐点较为明确。国内方面，更加注重做好跨周期和逆周期调节，预计将保持偏呵护状态，以“营造良好的货币金融环境”。<br/>策略方面，2024 年，A 股市场的业绩和估值将迎来共振过程，以投资端改革为推动的政策周期的到来，有望使 A 股全年实现攀升。行业配置方面，可沿着以下两条主线进行关注，一是产业趋势催化下的主题性博弈机会，可关注：（1）AI 模型由云向端，供给创新开启需求新周期下，以电子行业为核心的 TMT 板块；（2）汽车行业变革下半场——智能化驱动下的汽车行业。",
        },
        {
          name: "华安证券",
          pointView: "渐入佳境慢牛可期",
          content:
            "1、国内：渐入佳境，5%增速犹可期<br/>2、海外：补库接续，衰退后延<br/>3、政策：万象更新，向阳而动<br/>4、盈利：显著改善，慢牛基石<br/>5、配置：成长、消费交替演绎",
        },
      ],
    };
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {},
  methods: {},
};
</script>
    <style lang="scss" scoped>
// 清除浮动
.clearfix:before,
.clearfix:after {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}
.activity-wrap {
  background: #ededed;
  overflow: hidden;
  overflow: hidden;
  .banner_main {
    width: 100%;
    height: 220px;
    margin-bottom: 22px;
    background: url("../../assets/images/activity/activityforecast2024/jgcl_hander.png")
      no-repeat;
    background-size: 100% 100%;
    .content_box {
      width: 900px;
      height: 100%;
      margin: 0 auto;
      text-align: center;
      padding-top: 35px;
      box-sizing: border-box;
      img {
        width: 675px;
        height: 137px;
      }
    }
  }
  .content_main {
    width: 900px;
    margin: 0 auto;
    background-color: #fff;
    padding: 0 20px 37px;
    box-sizing: border-box;
    .main_box {
      width: 100%;
      .header_main {
        width: 100%;
        height: 106px;
        border-bottom: 2px solid rgba(237, 237, 237, 1);
        padding-top: 32px;
        text-align: center;
        p {
          &:first-child {
            font-size: 37px;
            color: rgba(54, 54, 54, 1);
          }
          &:last-child {
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 22px;
            letter-spacing: 0px;
            color: rgba(54, 54, 54, 0.3);
          }
        }
      }
      .text_box {
        font-size: 18px;
        line-height: 36px;
        letter-spacing: 0px;
        color: rgba(119, 119, 119, 1);
        padding: 23px 0 29px 0;
        box-sizing: border-box;
      }
      .table_main_box {
        width: 100%;
        table {
          width: 100%;
          border: 1px solid rgba(246, 223, 133, 1);
          th {
            height: 62px;
            background-color: rgba(254, 225, 110, 1);
            line-height: 62px;
            font-size: 20px;
            color: rgba(85, 85, 85, 1);
          }
          tr {
            td {
              height: 42px;
              list-style: 42px;
              font-size: 18px;
              border: 1px solid rgba(246, 223, 133, 1);
              color: rgba(85, 85, 85, 1);
              text-align: center;
              padding: 14px 30px;
							&:first-child {
								padding: 0;
							}
							&:nth-child(2) {
								text-align: left;
								line-height: 36px;
							}
							&:nth-child(3) {
								text-align: left;
								line-height: 36px;
							}
            }
          }
        }
      }
    }
  }
  .footer_box {
    margin: 27px 0;
    text-align: center;
    font-size: 12px;
    color: rgba(85, 85, 85, 0.3);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/activityInstitutionStrategy2024.vue